import { render, staticRenderFns } from "./StartupItem.vue?vue&type=template&id=0d6568e4&scoped=true&"
import script from "./StartupItem.vue?vue&type=script&lang=js&"
export * from "./StartupItem.vue?vue&type=script&lang=js&"
import style0 from "./StartupItem.vue?vue&type=style&index=0&id=0d6568e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6568e4",
  null
  
)

export default component.exports